(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[655],{

/***/ 40098:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 47445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(40098),
    isIterateeCall = __webpack_require__(16612),
    toFinite = __webpack_require__(18601);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(10355),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 96026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(47445);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 78196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ setContractLastManuallyVerified; },
/* harmony export */   "N$": function() { return /* binding */ useContractsFreshness; },
/* harmony export */   "O$": function() { return /* binding */ setContractCategory; },
/* harmony export */   "pG": function() { return /* binding */ setContractTwitterHandle; },
/* harmony export */   "pv": function() { return /* binding */ setContractName; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23855);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66604);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20929);




const setContractTwitterHandle = async (address, handle, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-twitter-handle?address=").concat(address, "&token=").concat(token, "&handle=").concat(handle));
    if (res.status !== 200) {
        console.error("failed to add twitter handle", await res.json());
        return;
    }
    console.log("successfully twitter handle ".concat(handle, " for ").concat(address));
};
const setContractName = async (address, name, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-name?address=").concat(address, "&token=").concat(token, "&name=").concat(name));
    if (res.status !== 200) {
        console.error("failed to add contract name", await res.json());
        return;
    }
    console.log("successfully added contract name ".concat(name, " for ").concat(address));
};
const setContractCategory = async (address, category, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-category?address=").concat(address, "&token=").concat(token, "&category=").concat(category));
    if (res.status !== 200) {
        console.error("failed to add contract category", await res.json());
        return;
    }
    console.log("successfully added category ".concat(category, " for ").concat(address));
};
const setContractLastManuallyVerified = async (address, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-last-manually-verified?address=").concat(address, "&token=").concat(token));
    if (res.status !== 200) {
        console.error("failed to add contract category", await res.json());
        return;
    }
    console.log("successfully set last manually verified for ".concat(address));
};
const decodeFreshness = (freshness)=>({
        openseaContractLastFetch: freshness.openseaContractLastFetch == null ? undefined : date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(freshness.openseaContractLastFetch),
        lastManuallyVerified: freshness.lastManuallyVerified == null ? undefined : date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(freshness.lastManuallyVerified)
    });
const useContractsFreshness = (addresses, token)=>{
    const shouldFetch = addresses !== undefined && token !== undefined;
    const fetcher = (url)=>fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                addresses
            })
        }).then(async (res)=>{
            if (!res.ok) {
                console.log(await res.json());
                throw new Error("failed to fetch contract metadata freshness");
            }
            return res.json();
        });
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(shouldFetch ? "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/metadata-freshness?token=").concat(token) : null, fetcher);
    return data === undefined ? undefined : lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default()(data, decodeFreshness);
};


/***/ }),

/***/ 28951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ decodeGroupedAnalysis1; },
  "a": function() { return /* binding */ useGroupedAnalysis1; }
});

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/duration.ts
var duration = __webpack_require__(5964);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
;// CONCATENATED MODULE: ./src/mainsite/api/burn-records.ts


const decodeBurnRecords = (rawBurnRecords)=>({
        ...rawBurnRecords,
        records: mapValues_default()(rawBurnRecords.records, (records)=>records.map((record)=>({
                    ...record,
                    minedAt: parseISO/* default */.Z(record.minedAt)
                })))
    });

// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/grouped-analysis-1.ts




const decodeGroupedAnalysis1 = (raw)=>raw === undefined ? undefined : {
        ...raw,
        burnRecords: decodeBurnRecords({
            number: raw.number,
            records: raw.burnRecords
        }).records
    };
const useGroupedAnalysis1 = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/fees/grouped-analysis-1", fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromSeconds */.Io(4)
    });
    return data;
};


/***/ }),

/***/ 45318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AdminControls; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__(59910);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMethods = __webpack_require__(93645);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js




/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInMilliseconds/* default */.Z)(dateLeft, dateRight) / constants/* millisecondsInHour */.vh;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceStrict/index.js + 3 modules
var formatDistanceStrict = __webpack_require__(63016);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js


/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */

function formatDistanceToNowStrict(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,formatDistanceStrict/* default */.Z)(dirtyDate, Date.now(), options);
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-admin-token.ts
var use_admin_token = __webpack_require__(11331);
// EXTERNAL MODULE: ./src/mainsite/api/contracts.ts
var contracts = __webpack_require__(78196);
;// CONCATENATED MODULE: ./src/mainsite/components/AdminControls.tsx





const onSetTwitterHandle = async (address, token)=>{
    const handle = window.prompt("input twitter handle");
    if (handle === null) {
        return;
    }
    await contracts/* setContractTwitterHandle */.pG(address, handle, token);
};
const onSetName = async (address, token)=>{
    const nameInput = window.prompt("input name");
    if (nameInput === null) {
        return;
    }
    await contracts/* setContractName */.pv(address, nameInput, token);
};
const onSetCategory = async (address, token)=>{
    const category = window.prompt("input category");
    if (category === null) {
        return;
    }
    await contracts/* setContractCategory */.O$(address, category, token);
};
const getOpacityFromAge = (now, dt)=>dt === undefined || now === undefined ? 0.8 : Math.min(0.8, 0.2 + 0.6 / 168 * differenceInHours(now, dt));
const AdminControls = (param)=>{
    let { address , freshness  } = param;
    const adminToken = (0,use_admin_token/* useAdminToken */.F)();
    const [now, setNow] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        setNow(new Date());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-4 opacity-80",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            onSetTwitterHandle(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set handle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            onSetName(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            onSetCategory(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set category"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            contracts/* setContractLastManuallyVerified */.IX(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set verified"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 flex gap-x-4 text-sm text-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "rounded-lg bg-slate-700 py-1 px-2",
                        style: {
                            opacity: getOpacityFromAge(now, freshness === null || freshness === void 0 ? void 0 : freshness.openseaContractLastFetch)
                        },
                        children: (freshness === null || freshness === void 0 ? void 0 : freshness.openseaContractLastFetch) === undefined ? "never fetched" : "opensea fetch ".concat(formatDistanceToNowStrict(freshness.openseaContractLastFetch), " ago")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "rounded-lg bg-slate-700 py-1 px-2",
                        style: {
                            opacity: getOpacityFromAge(now, freshness === null || freshness === void 0 ? void 0 : freshness.lastManuallyVerified)
                        },
                        children: (freshness === null || freshness === void 0 ? void 0 : freshness.lastManuallyVerified) === undefined ? "never verified" : "last verified ".concat(formatDistanceToNowStrict(freshness.lastManuallyVerified), " ago")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AdminControls = (AdminControls);


/***/ }),

/***/ 37343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "timeframeFeesBurnedMap": function() { return /* binding */ timeframeFeesBurnedMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89802);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17857);
/* harmony import */ var _assets_fire_own_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83915);
/* harmony import */ var _Amount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30772);
/* harmony import */ var _components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69443);
/* harmony import */ var _api_grouped_analysis_1__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28951);
/* harmony import */ var _TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62925);









const GWEI_FORMATTING_THRESHOLD = 1e15; // Threshold in wei below which to convert format as Gwei instead of ETH
const MIN_BURN_DECIMALS = 2;
const BURN_USD_DECIMALS = 0;
const timeframeFeesBurnedMap = {
    m5: {
        eth: "feesBurned5m",
        usd: "feesBurned5mUsd"
    },
    h1: {
        eth: "feesBurned1h",
        usd: "feesBurned1hUsd"
    },
    d1: {
        eth: "feesBurned24h",
        usd: "feesBurned24hUsd"
    },
    d7: {
        eth: "feesBurned7d",
        usd: "feesBurned7dUsd"
    },
    d30: {
        eth: "feesBurned30d",
        usd: "feesBurned30dUsd"
    },
    since_merge: {
        eth: "feesBurnedSinceMerge",
        usd: "feesBurnedSinceMergeUsd"
    },
    since_burn: {
        eth: "feesBurnedSinceBurn",
        usd: "feesBurnedSinceBurnUsd"
    }
};
function firstNonZeroDecimalPosition(num) {
    // If the number is >= 1, return 0
    if (num >= 1) {
        return 0;
    }
    // Convert the number to a string to inspect its decimal part
    const strNum = num.toFixed(20).toString();
    // Extract the decimal part by removing everything up to and including the decimal point
    const decimalPart = strNum.split(".")[1] || "";
    // Find the position of the first non-zero digit in the decimal part
    for(let i = 0; i < decimalPart.length; i++){
        if (decimalPart[i] !== "0") {
            // Return the position (i + 1 because position is 1-indexed in this context)
            return i + 1;
        }
    }
    // If there are no non-zero decimals (or the number is 0), it means all decimals are zero
    return decimalPart.length ? decimalPart.length : 0;
}
const BlobBurnWidget = (param)=>{
    let { onClickTimeFrame , timeFrame  } = param;
    const groupedAnalysis1F = (0,_api_grouped_analysis_1__WEBPACK_IMPORTED_MODULE_7__/* .useGroupedAnalysis1 */ .a)();
    const groupedAnalysis1 = (0,_api_grouped_analysis_1__WEBPACK_IMPORTED_MODULE_7__/* .decodeGroupedAnalysis1 */ .h)(groupedAnalysis1F);
    const feesBurned = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.blobFeeBurns;
    const blobFeeBurn = feesBurned === undefined ? undefined : feesBurned[timeframeFeesBurnedMap[timeFrame]["eth"]];
    const blobFeeBurnUSD = feesBurned === undefined ? undefined : feesBurned[timeframeFeesBurnedMap[timeFrame]["usd"]];
    const formatBurnAsGwei = blobFeeBurn !== undefined && blobFeeBurn < GWEI_FORMATTING_THRESHOLD;
    const formattedBurn = blobFeeBurn !== undefined ? blobFeeBurn / (formatBurnAsGwei ? 1e9 : 1e18) : undefined;
    const burnDecimals = formattedBurn == undefined ? undefined : Math.max(firstNonZeroDecimalPosition(formattedBurn), MIN_BURN_DECIMALS);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__/* .WidgetBackground */ .K, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                children: "blob fee burn"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                timeFrame: timeFrame,
                                onClickTimeFrame: onClickTimeFrame
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Amount__WEBPACK_IMPORTED_MODULE_5__/* .AmountAnimatedShell */ .au, {
                                skeletonWidth: "9rem",
                                size: "text-2xl md:text-3xl lg:text-3xl xl:text-4xl",
                                unitText: formatBurnAsGwei ? "Gwei" : "ETH",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    decimals: burnDecimals,
                                    duration: 0.8,
                                    end: formattedBurn !== null && formattedBurn !== void 0 ? formattedBurn : 0,
                                    preserveValue: true,
                                    separator: ","
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-4 h-6 w-6 select-none md:ml-8 lg:h-8 lg:w-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    alt: "fire emoji symbolizing ETH burned",
                                    src: _assets_fire_own_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center gap-x-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-baseline gap-x-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Amount__WEBPACK_IMPORTED_MODULE_5__/* .AmountAnimatedShell */ .au, {
                        skeletonWidth: "2rem",
                        size: "text-m",
                        unitText: "USD",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            decimals: BURN_USD_DECIMALS,
                            duration: 0.8,
                            end: blobFeeBurnUSD !== null && blobFeeBurnUSD !== void 0 ? blobFeeBurnUSD : 0,
                            preserveValue: true,
                            separator: ","
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlobBurnWidget);


/***/ }),

/***/ 31655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_BurnDashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Section.tsx
var Section = __webpack_require__(33040);
// EXTERNAL MODULE: ./src/components/TimeFrameControl.tsx + 3 modules
var TimeFrameControl = __webpack_require__(5429);
// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/burn-categories.ts


const categoryId = [
    "cex",
    "defi",
    // Contract creations is a special case and currently injected on the frontend.
    "creations",
    "blobs",
    // Eth transfers is a special case and currently injected on the frontend.
    "transfers",
    "gaming",
    "l1",
    "l1-bridge",
    "l2",
    "mev",
    // Misc is a special case and currently injected on the frontend.
    "misc",
    "nft",
    "woof"
];
const categoryDisplayMap = {
    "l1-bridge": "L1 bridge",
    cex: "CEX",
    defi: "defi",
    gaming: "gaming",
    l1: "L1",
    l2: "L2",
    mev: "MEV",
    misc: "misc",
    nft: "NFTs",
    transfers: "ETH transfers",
    creations: "contract creations",
    blobs: "blob fees",
    woof: "woof"
};
const getIsKnownCategory = (u)=>typeof u === "string" && categoryId.includes(u);
const useBurnCategories = ()=>{
    const { data  } = (0,swr_dist/* default */.ZP)("/api/fees/burn-categories", fetchers/* fetchJsonSwr */.Ar);
    return data;
};

// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(71637);
// EXTERNAL MODULE: ./src/eth-units.ts
var eth_units = __webpack_require__(41492);
// EXTERNAL MODULE: ./src/feature-flags.ts
var feature_flags = __webpack_require__(58739);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/mainsite/time-frames.ts
var time_frames = __webpack_require__(78868);
// EXTERNAL MODULE: ./src/components/Texts.tsx
var Texts = __webpack_require__(90917);
// EXTERNAL MODULE: ./src/components/TextsNext/LabelText.tsx
var LabelText = __webpack_require__(89802);
// EXTERNAL MODULE: ./src/mainsite/components/TimeFrameIndicator.tsx
var TimeFrameIndicator = __webpack_require__(62925);
;// CONCATENATED MODULE: ./src/mainsite/components/BurnGroupBase.tsx



const BurnGroupBase = (param)=>/*#__PURE__*/ {
    let { backgroundClassName , children , onClickTimeFrame , timeFrame , title  } = param;
    return (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
        className: backgroundClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-baseline justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameIndicator/* default */.Z, {
                        onClickTimeFrame: onClickTimeFrame,
                        timeFrame: timeFrame
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var components_BurnGroupBase = (BurnGroupBase);

// EXTERNAL MODULE: ./src/components/TextsNext/QuantifyText.tsx
var QuantifyText = __webpack_require__(90079);
// EXTERNAL MODULE: ./src/components/TextsNext/SkeletonText.tsx
var SkeletonText = __webpack_require__(7569);
// EXTERNAL MODULE: ./src/mainsite/api/burn-sums.ts
var burn_sums = __webpack_require__(46983);
// EXTERNAL MODULE: ./src/fp.ts
var fp = __webpack_require__(96019);
// EXTERNAL MODULE: ./src/mainsite/api/grouped-analysis-1.ts + 1 modules
var grouped_analysis_1 = __webpack_require__(28951);
// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(95237);
// EXTERNAL MODULE: ./src/components/WidgetErrorBoundary.tsx + 1 modules
var WidgetErrorBoundary = __webpack_require__(46400);
// EXTERNAL MODULE: ./src/hooks/use-admin-token.ts
var use_admin_token = __webpack_require__(11331);
// EXTERNAL MODULE: ./src/styles/Scrollbar.module.scss
var Scrollbar_module = __webpack_require__(23195);
var Scrollbar_module_default = /*#__PURE__*/__webpack_require__.n(Scrollbar_module);
// EXTERNAL MODULE: ./src/mainsite/api/contracts.ts
var contracts = __webpack_require__(78196);
// EXTERNAL MODULE: ./src/mainsite/utils/use-active-breakpoint.ts
var use_active_breakpoint = __webpack_require__(95251);
// EXTERNAL MODULE: ./src/mainsite/components/FamTooltip.tsx + 1 modules
var FamTooltip = __webpack_require__(93964);
// EXTERNAL MODULE: ./src/mainsite/components/Modal.tsx
var Modal = __webpack_require__(33181);
// EXTERNAL MODULE: ./src/mainsite/components/Amount.tsx
var Amount = __webpack_require__(30772);
// EXTERNAL MODULE: ./src/mainsite/components/ImageWithTooltip.tsx + 1 modules
var ImageWithTooltip = __webpack_require__(13852);
// EXTERNAL MODULE: ./src/mainsite/components/AdminControls.tsx + 2 modules
var AdminControls = __webpack_require__(45318);
;// CONCATENATED MODULE: ./src/mainsite/components/BurnLeaderboard/LeaderboardRow.tsx









const LeaderboardRow = (param)=>{
    let { address , adminToken , category , detail , fees , freshness , onClickImage , onMouseLeaveImage , onMouseEnterImage , image , isBot , name , type , unit  } = param;
    const { showCategorySlugs , showMetadataTools  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    const imgSrc = typeof image === "string" ? image : type === "eth-transfers" ? "/leaderboard-images/transfer-v2.svg" : isBot ? "/leaderboard-images/bot-v2.svg" : type === "contract-creations" ? "/leaderboard-images/contract-creations.svg" : type === "blob-fees" ? "/leaderboard-images/blob-fees.svg" : undefined;
    const isDoneLoading = type !== undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pt-2.5 pr-2 pb-2.5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex text-white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTooltip/* default */.Z, {
                            onMouseEnter: isBot ? undefined : onMouseEnterImage,
                            onMouseLeave: onMouseLeaveImage,
                            onClick: onClickImage,
                            className: "flex items-center rounded-full select-none",
                            isDoneLoading: isDoneLoading,
                            imageUrl: imgSrc,
                            width: 32,
                            height: 32
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "\n              flex\n              w-full flex-row items-center\n              truncate font-inter\n              text-base font-light text-white\n              md:text-lg\n              ".concat(address !== undefined ? "hover:opacity-60" : "", "\n            "),
                            href: address === undefined ? undefined : "https://etherscan.io/address/".concat(address),
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pl-4 truncate",
                                    children: typeof name === "string" ? name : typeof address === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-roboto",
                                        children: [
                                            "0x" + address.slice(2, 6),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-inter",
                                                children: "..."
                                            }),
                                            address.slice(38, 42)
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        inline: true,
                                        width: "12rem"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "\n                ml-2 hidden whitespace-nowrap\n                rounded-sm bg-slateus-600\n                px-1.5\n                py-0.5\n                text-sm\n                font-normal\n                text-slateus-400 md:block\n                ".concat(category ? "block" : "md:hidden", "\n              "),
                                    children: showCategorySlugs ? category : getIsKnownCategory(category) ? categoryDisplayMap[category] : format/* capitalize */.kC(category)
                                }),
                                detail && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hidden pl-2 font-extralight md:block lg:hidden xl:block truncate text-slateus-400",
                                    children: detail
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pl-4 ml-auto whitespace-nowrap",
                                    children: fees === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        inline: true,
                                        width: "4rem"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* QuantifyTextAnimated */.Ix, {
                                        unit: unit || "eth",
                                        unitText: unit === "eth" ? "ETH" : "USD",
                                        children: fees
                                    })
                                })
                            ]
                        })
                    ]
                }),
                adminToken !== undefined && address !== undefined && showMetadataTools && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminControls/* default */.Z, {
                    address: address,
                    freshness: freshness
                })
            ]
        })
    });
};
/* harmony default export */ var BurnLeaderboard_LeaderboardRow = (LeaderboardRow);

;// CONCATENATED MODULE: ./src/mainsite/components/BurnLeaderboard/index.tsx














const leaderboardKeyFromTimeFrame = {
    m5: "leaderboard5m",
    h1: "leaderboard1h",
    d1: "leaderboard24h",
    d7: "leaderboard7d",
    d30: "leaderboard30d",
    since_merge: "leaderboardSinceMerge",
    since_burn: "leaderboardSinceBurn"
};
const formatName = (rawName, address)=>{
    if (typeof rawName !== "string" && typeof address !== "string") {
        // We have neither.
        return undefined;
    }
    if (typeof rawName !== "string") {
        if (typeof address !== "string") {
            // Should never happen. If there is no name there should always be an address available.
            return undefined;
        }
        return undefined;
    }
    // We have a name
    // It's possible the name is actually an address.
    // To deprecate this:
    // * deploy a frontend that falls back to address when name is missing.
    if (rawName.startsWith("0x") && rawName.length === 42) {
        return undefined;
    // return <FormattedAddress address={rawName} />;
    }
    // Contract names are really an encoded format of shape: `name: details`. We decode the name portion.
    // To deprecate this:
    // * deploy a frontend that relies on the detail field in leaderboard entries.
    const name = rawName.split(":")[0];
    return name;
};
const formatDetail = (rawName, detail)=>{
    if (typeof rawName !== "string" && typeof detail !== "string") {
        return undefined;
    }
    if (typeof detail === "string") {
        return detail;
    }
    return undefined;
};
const getLeaderboardsAddresses = (leaderboards)=>Object.values(leaderboards).flatMap((leaderboardEntries)=>leaderboardEntries.map((entry)=>entry.type === "contract" ? entry.address : undefined)).filter((mAddress)=>mAddress !== undefined);
const useTooltip = ()=>{
    const { md  } = (0,use_active_breakpoint/* useActiveBreakpoint */.P)();
    const [refEl, setRefEl] = (0,react.useState)(null);
    const [popperEl, setPopperEl] = (0,react.useState)(null);
    const { styles , attributes  } = (0,usePopper/* usePopper */.D)(refEl, popperEl, {
        placement: "right",
        modifiers: [
            {
                name: "flip"
            }
        ]
    });
    const [selectedEntry, setSelectedEntry] = (0,react.useState)();
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const onTooltip = (0,react.useRef)(false);
    const onImage = (0,react.useRef)(false);
    const handleImageMouseEnter = (0,react.useCallback)((entry, ref)=>{
        // The ranking data isn't there yet so no tooltip can be shown.
        if (entry === undefined || entry.type !== "contract" || entry.isBot === true) {
            return;
        }
        onImage.current = true;
        // Delayed show.
        const id = window.setTimeout(()=>{
            if (onImage.current || onTooltip.current) {
                setRefEl(ref.current);
                setSelectedEntry(entry);
                setShowTooltip(true);
            }
        }, 300);
        return ()=>window.clearTimeout(id);
    }, [
        onImage,
        onTooltip
    ]);
    const handleImageMouseLeave = (0,react.useCallback)(()=>{
        onImage.current = false;
        // Delayed hide.
        const id = window.setTimeout(()=>{
            if (!onImage.current && !onTooltip.current) {
                setShowTooltip(false);
                setSelectedEntry(undefined);
            }
        }, 300);
        return ()=>window.clearTimeout(id);
    }, [
        onImage,
        onTooltip
    ]);
    const handleTooltipEnter = (0,react.useCallback)(()=>{
        onTooltip.current = true;
    }, []);
    const handleTooltipLeave = (0,react.useCallback)(()=>{
        onTooltip.current = false;
        // Delayed hide.
        const id = window.setTimeout(()=>{
            if (!onImage.current && !onTooltip.current) {
                setShowTooltip(false);
                setSelectedEntry(undefined);
            }
        }, 100);
        return ()=>window.clearTimeout(id);
    }, [
        onImage,
        onTooltip
    ]);
    const handleClickImage = (0,react.useCallback)((ranking)=>{
        if (md || (ranking === null || ranking === void 0 ? void 0 : ranking.type) !== "contract") {
            return;
        }
        setSelectedEntry(ranking);
    }, [
        md,
        setSelectedEntry
    ]);
    return {
        attributes,
        handleClickImage,
        handleImageMouseEnter,
        handleImageMouseLeave,
        handleTooltipEnter,
        handleTooltipLeave,
        selectedEntry,
        setPopperEl,
        setSelectedEntry,
        showTooltip,
        popperStyles: styles
    };
};
const BurnLeaderboard = (param)=>{
    let { onClickTimeFrame , timeFrame , unit  } = param;
    const groupedAnalysisF = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const groupedAnalysis1 = (0,grouped_analysis_1/* decodeGroupedAnalysis1 */.h)(groupedAnalysisF);
    const leaderboards = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.leaderboards;
    const selectedLeaderboard = leaderboards === undefined ? undefined : leaderboards[leaderboardKeyFromTimeFrame[timeFrame]];
    const adminToken = (0,use_admin_token/* useAdminToken */.F)();
    const addresses = leaderboards === undefined ? undefined : getLeaderboardsAddresses(leaderboards);
    const freshnessMap = (0,contracts/* useContractsFreshness */.N$)(addresses, adminToken);
    const { attributes , handleClickImage , handleTooltipEnter , handleTooltipLeave , handleImageMouseLeave , handleImageMouseEnter , selectedEntry , setPopperEl , setSelectedEntry , showTooltip , popperStyles  } = useTooltip();
    const { md  } = (0,use_active_breakpoint/* useActiveBreakpoint */.P)();
    var _image, ref, _image1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetErrorBoundary/* default */.Z, {
        title: "burn leaderboard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnGroupBase, {
                backgroundClassName: "flex flex-col gap-y-4 h-[567px]",
                onClickTimeFrame: onClickTimeFrame,
                title: "burn leaderboard",
                timeFrame: timeFrame,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "\n            -mt-1 -mr-3\n            overflow-y-auto overflow-x-hidden\n            ".concat((Scrollbar_module_default())["styled-scrollbar-vertical"], "\n            ").concat((Scrollbar_module_default())["styled-scrollbar"], "\n          "),
                    children: selectedLeaderboard === undefined ? range_default()(0, 100).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BurnLeaderboard_LeaderboardRow, {}, index)) : selectedLeaderboard.map((entry, index)=>entry.type === "contract" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BurnLeaderboard_LeaderboardRow, {
                            address: entry.address,
                            adminToken: adminToken,
                            category: entry.category || undefined,
                            detail: formatDetail(entry.name, entry.detail),
                            fees: unit === "eth" ? entry.fees : entry.feesUsd,
                            onClickImage: ()=>md ? ()=>undefined : handleClickImage(entry),
                            onMouseEnterImage: (ref)=>!md ? ()=>undefined : handleImageMouseEnter(entry, ref),
                            onMouseLeaveImage: ()=>!md ? ()=>undefined : handleImageMouseLeave(),
                            freshness: entry.address === undefined || freshnessMap === undefined ? undefined : freshnessMap[entry.address],
                            image: (_image = entry.image) !== null && _image !== void 0 ? _image : undefined,
                            isBot: entry.isBot,
                            name: formatName(entry.name, entry.address),
                            type: entry.type,
                            unit: unit
                        }, entry.address) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BurnLeaderboard_LeaderboardRow, {
                            fees: unit === "eth" ? entry.fees : entry.feesUsd,
                            name: formatName(entry.name, undefined),
                            type: entry.type,
                            unit: unit
                        }, entry.type || index))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: setPopperEl,
                        className: "hidden z-20 p-4 md:block",
                        style: {
                            ...popperStyles.popper,
                            visibility: showTooltip && md ? "visible" : "hidden"
                        },
                        ...attributes.popper,
                        onMouseEnter: handleTooltipEnter,
                        onMouseLeave: handleTooltipLeave,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FamTooltip/* default */.Z, {
                            contractAddresses: selectedEntry === undefined ? undefined : [
                                selectedEntry.address
                            ],
                            description: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.twitterBio,
                            links: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.twitterLinks,
                            famFollowerCount: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.famFollowerCount,
                            followerCount: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.followerCount,
                            imageUrl: (ref = selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.image) !== null && ref !== void 0 ? ref : undefined,
                            onClickClose: ()=>setSelectedEntry(undefined),
                            title: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.twitterName,
                            twitterUrl: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.twitterUrl,
                            width: "min-w-[18rem] max-w-sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        onClickBackground: ()=>setSelectedEntry(undefined),
                        show: !md && selectedEntry !== undefined,
                        children: !md && selectedEntry !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(FamTooltip/* default */.Z, {
                            contractAddresses: [
                                selectedEntry.address
                            ],
                            description: selectedEntry.twitterBio,
                            famFollowerCount: selectedEntry.famFollowerCount,
                            followerCount: selectedEntry.followerCount,
                            imageUrl: (_image1 = selectedEntry.image) !== null && _image1 !== void 0 ? _image1 : undefined,
                            onClickClose: ()=>setSelectedEntry(undefined),
                            title: selectedEntry.twitterName,
                            twitterUrl: selectedEntry.twitterUrl,
                            width: "min-w-[18rem] max-w-sm"
                        })
                    })
                ]
            })
        ]
    });
};
// TODO: document why we memo here.
/* harmony default export */ var components_BurnLeaderboard = (/*#__PURE__*/(0,react.memo)(BurnLeaderboard));

;// CONCATENATED MODULE: ./src/assets/question-mark-slateus.svg
/* harmony default export */ var question_mark_slateus = ({"src":"/_next/static/media/question-mark-slateus.1e96b4ef.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/question-mark-own.svg
/* harmony default export */ var question_mark_own = ({"src":"/_next/static/media/question-mark-own.16dbff6c.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/palette-slateus.svg
/* harmony default export */ var palette_slateus = ({"src":"/_next/static/media/palette-slateus.890e318a.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/palette-own.svg
/* harmony default export */ var palette_own = ({"src":"/_next/static/media/palette-own.45f629f5.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/robot-slateus.svg
/* harmony default export */ var robot_slateus = ({"src":"/_next/static/media/robot-slateus.603ded13.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/robot-own.svg
/* harmony default export */ var robot_own = ({"src":"/_next/static/media/robot-own.33c60d0e.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/money-wings-slateus.svg
/* harmony default export */ var money_wings_slateus = ({"src":"/_next/static/media/money-wings-slateus.2a18292c.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/money-wings-own.svg
/* harmony default export */ var money_wings_own = ({"src":"/_next/static/media/money-wings-own.841d3f81.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/dots-slateus.svg
/* harmony default export */ var dots_slateus = ({"src":"/_next/static/media/dots-slateus.ba70b506.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/dots-own.svg
/* harmony default export */ var dots_own = ({"src":"/_next/static/media/dots-own.f1be195d.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/transfers-slateus.svg
/* harmony default export */ var transfers_slateus = ({"src":"/_next/static/media/transfers-slateus.73cedf37.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/transfers-own.svg
/* harmony default export */ var transfers_own = ({"src":"/_next/static/media/transfers-own.248292e1.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/chains-slateus.svg
/* harmony default export */ var chains_slateus = ({"src":"/_next/static/media/chains-slateus.8e5338c7.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/chains-own.svg
/* harmony default export */ var chains_own = ({"src":"/_next/static/media/chains-own.2531088c.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/copy-slateus.svg
/* harmony default export */ var copy_slateus = ({"src":"/_next/static/media/copy-slateus.5367fb57.svg","height":32,"width":31});
;// CONCATENATED MODULE: ./src/assets/copy-own.svg
/* harmony default export */ var copy_own = ({"src":"/_next/static/media/copy-own.9f61fc07.svg","height":32,"width":31});
;// CONCATENATED MODULE: ./src/assets/bridge-slateus.svg
/* harmony default export */ var bridge_slateus = ({"src":"/_next/static/media/bridge-slateus.1ab9c419.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/bridge-own.svg
/* harmony default export */ var bridge_own = ({"src":"/_next/static/media/bridge-own.4dec5ac4.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/chart-slateus.svg
/* harmony default export */ var chart_slateus = ({"src":"/_next/static/media/chart-slateus.77eea239.svg","height":100,"width":101});
;// CONCATENATED MODULE: ./src/assets/chart-own.svg
/* harmony default export */ var chart_own = ({"src":"/_next/static/media/chart-own.b9188210.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/md-bubble-chart-own.svg
/* harmony default export */ var md_bubble_chart_own = ({"src":"/_next/static/media/md-bubble-chart-own.9ddc98cb.svg","height":32,"width":32});
;// CONCATENATED MODULE: ./src/assets/md-bubble-chart-slateus.svg
/* harmony default export */ var md_bubble_chart_slateus = ({"src":"/_next/static/media/md-bubble-chart-slateus.8cc52384.svg","height":32,"width":32});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/mainsite/components/BlobBurnWidget.tsx
var BlobBurnWidget = __webpack_require__(37343);
;// CONCATENATED MODULE: ./src/mainsite/components/BurnCategoryWidget.tsx












































const activeCategories = [
    "nft",
    "l2",
    "mev",
    "defi",
    "transfers",
    "creations",
    "blobs"
];
const alwaysShowImgPercentThreshold = 0.08;
const separatorWidth = 1;
// -1 because separators are in between items, +1 because we add misc.
const separatorCount = activeCategories.length - 1 + 1;
const skeletonLoadingWidth = 0.1;
const CategorySegment = (param)=>/*#__PURE__*/ {
    let { imgAlt , imgName , onHoverCategory , percentOfTotalBurn , rounded , showHighlight  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center select-none",
        style: {
            width: "calc(".concat((percentOfTotalBurn !== null && percentOfTotalBurn !== void 0 ? percentOfTotalBurn : 0.1) * 100, "% - ").concat(separatorWidth * separatorCount, "px)")
        },
        onMouseEnter: ()=>onHoverCategory(true),
        onMouseLeave: ()=>onHoverCategory(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "relative w-6",
                height: 21,
                width: 21,
                src: imgName.coloroff,
                alt: imgAlt,
                style: {
                    height: "21px",
                    marginBottom: "12px",
                    visibility: percentOfTotalBurn === undefined ? "hidden" : percentOfTotalBurn < alwaysShowImgPercentThreshold ? "hidden" : "visible"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "absolute w-6",
                height: 21,
                width: 21,
                src: imgName.coloron,
                alt: "colored ice crystal, signifying staked ETH",
                style: {
                    height: "21px",
                    marginBottom: "12px",
                    visibility: percentOfTotalBurn === undefined ? "hidden" : showHighlight ? "visible" : "hidden"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "color-animation h-2 w-full bg-slateus-200 ".concat(rounded === "left" ? "rounded-l-full" : rounded === "right" ? "rounded-r-full" : ""),
                style: {
                    backgroundColor: showHighlight ? colors/* default.white */.Z.white : colors/* default.slateus200 */.Z.slateus200
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginTop: "9px"
                },
                children: percentOfTotalBurn === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    width: "1.5rem"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                    font: "font-roboto",
                    className: "color-animation ".concat(!showHighlight && percentOfTotalBurn < alwaysShowImgPercentThreshold ? "invisible" : "visible"),
                    style: {
                        color: showHighlight ? colors/* default.white */.Z.white : colors/* default.slateus200 */.Z.slateus200
                    },
                    children: [
                        format/* formatZeroDecimals */.UY((percentOfTotalBurn !== null && percentOfTotalBurn !== void 0 ? percentOfTotalBurn : skeletonLoadingWidth) * 100),
                        "%"
                    ]
                })
            })
        ]
    });
};
const CategoryRow = (param)=>/*#__PURE__*/ {
    let { amountFormatted , countFormatted , hovering , id , name , setHovering , showCategoryCounts =false  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "\n      grid\n      grid-cols-2\n      ".concat(showCategoryCounts ? "md:grid-cols-3" : "", "\n    "),
        onMouseEnter: ()=>setHovering({
                type: "highlight",
                category: id
            }),
        onMouseLeave: ()=>setHovering({
                type: "unhighlight",
                category: id
            }),
        style: {
            opacity: hovering ? 0.6 : 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                font: "font-inter",
                size: "text-base md:text-lg",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                className: "text-right",
                size: "text-base md:text-lg",
                unitPostfix: "ETH",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                    className: "text-right",
                    width: "4rem",
                    children: amountFormatted
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                className: "\n        hidden\n        text-right ".concat(showCategoryCounts ? "md:block" : "", "\n      "),
                children: countFormatted === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    width: "5rem"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                    font: "font-roboto",
                    className: "text-right",
                    children: countFormatted
                })
            })
        ]
    });
};
const formatFees = (num)=>num === undefined ? undefined : (0,fp/* flow */.ls)((num)=>num / eth_units/* WEI_PER_ETH */.Du, format/* formatZeroDecimals */.UY)(num);
const formatCount = (num)=>num === undefined ? undefined : (0,fp/* flow */.ls)((num)=>num / 10 ** 3, (num)=>format/* formatOneDecimal */.F9(num) + "K")(num);
var _fees, _feesUsd, _transactionCount, _percentOfTotalBurn, _percentOfTotalBurnUsd;
const buildMiscCategory = (burnCategories, activeCategories, setHoveringMisc, hoveringMisc)=>burnCategories.filter((category)=>!activeCategories.includes(category.category)).reduce((sumCategory, category)=>({
            ...sumCategory,
            fees: ((_fees = sumCategory.fees) !== null && _fees !== void 0 ? _fees : 0) + category.fees,
            feesUsd: ((_feesUsd = sumCategory.feesUsd) !== null && _feesUsd !== void 0 ? _feesUsd : 0) + category.feesUsd,
            transactionCount: ((_transactionCount = sumCategory.transactionCount) !== null && _transactionCount !== void 0 ? _transactionCount : 0) + category.transactionCount,
            percentOfTotalBurn: ((_percentOfTotalBurn = sumCategory.percentOfTotalBurn) !== null && _percentOfTotalBurn !== void 0 ? _percentOfTotalBurn : 0) + category.percentOfTotalBurn,
            percentOfTotalBurnUsd: ((_percentOfTotalBurnUsd = sumCategory.percentOfTotalBurnUsd) !== null && _percentOfTotalBurnUsd !== void 0 ? _percentOfTotalBurnUsd : 0) + category.percentOfTotalBurnUsd,
            onHoverCategory: setHoveringMisc,
            showHighlight: hoveringMisc
        }), {
        id: "misc",
        imgName: {
            coloroff: dots_slateus,
            coloron: dots_own
        },
        imgAlt: "three dots, signaling the summing of other contracts that have been categorized",
        fees: 0,
        feesUsd: 0,
        transactionCount: 0,
        percentOfTotalBurn: 0,
        percentOfTotalBurnUsd: 0,
        onHoverCategory: setHoveringMisc,
        showHighlight: hoveringMisc
    });
const imgAltMap = {
    "l1-bridge": "a bridge, signaling L1 bridge fees",
    cex: "a bridge, signaling CEX bridge fees",
    defi: "an image of flying money, signaling DeFi",
    gaming: "a game controller, signaling gaming",
    l1: "a bridge, signaling L1 fees",
    l2: "a bridge, signaling L2 fees",
    mev: "a robot, signaling bots extracting miner-extractable-value",
    misc: "three dots, signaling the summing of other contracts that have been categorized",
    nft: "icon of a wooden painters palette, signaling NFTs",
    transfers: "an image of flying money, signaling ETH transfers",
    creations: "a copy icon, signaling contract creations",
    blobs: "a blob icon, signaling blob fees",
    woof: "a dog, signaling meme tokens"
};
const imgMap = {
    cex: {
        coloroff: chart_slateus,
        coloron: chart_own
    },
    nft: {
        coloroff: palette_slateus,
        coloron: palette_own
    },
    defi: {
        coloroff: money_wings_slateus,
        coloron: money_wings_own
    },
    gaming: {
        coloroff: question_mark_slateus,
        coloron: question_mark_own
    },
    l1: {
        coloroff: question_mark_slateus,
        coloron: question_mark_own
    },
    "l1-bridge": {
        coloroff: bridge_slateus,
        coloron: bridge_own
    },
    l2: {
        coloroff: chains_slateus,
        coloron: chains_own
    },
    mev: {
        coloroff: robot_slateus,
        coloron: robot_own
    },
    misc: {
        coloroff: dots_slateus,
        coloron: dots_own
    },
    transfers: {
        coloroff: transfers_slateus,
        coloron: transfers_own
    },
    creations: {
        coloroff: copy_slateus,
        coloron: copy_own
    },
    blobs: {
        coloroff: md_bubble_chart_slateus,
        coloron: md_bubble_chart_own
    },
    woof: {
        coloroff: question_mark_slateus,
        coloron: question_mark_own
    }
};
const initialState = {
    "l1-bridge": false,
    cex: false,
    defi: false,
    gaming: false,
    l1: false,
    l2: false,
    mev: false,
    misc: false,
    nft: false,
    transfers: false,
    creations: false,
    blobs: false,
    woof: false
};
const hoverReducer = (state, action)=>{
    switch(action.type){
        case "highlight":
            return {
                ...state,
                [action.category]: true
            };
        case "unhighlight":
            return {
                ...state,
                [action.category]: false
            };
        default:
            throw new Error();
    }
};
// We want to have separators in between the categories, but not at the end.
// We use a fragment to create one mixed list of separators and categories.
// This causes key errors, so we use a wrapper element.
const CategorySegmentItem = (param)=>/*#__PURE__*/ {
    let { isLast , category , isFirst  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySegment, {
                rounded: isFirst ? "left" : undefined,
                ...category
            }),
            !isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-10 w-0.5 h-2 bg-slateus-500"
            })
        ]
    });
};
const BurnCategoryWidget = (param)=>{
    let { onClickTimeFrame , timeFrame  } = param;
    var ref;
    const burnCategories = useBurnCategories();
    const groupedAnalysis1 = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const leaderboard = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : (ref = groupedAnalysis1.leaderboards) === null || ref === void 0 ? void 0 : ref[leaderboardKeyFromTimeFrame[timeFrame]];
    const feesBurned = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.blobFeeBurns;
    const burnSum = (0,burn_sums/* useBurnSums */.I)()[timeFrame];
    const [hoverState, dispatchHover] = (0,react.useReducer)(hoverReducer, initialState);
    const { showCategoryCounts  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    var _fees;
    const sortByFeesDesc = (0,fp/* pipe */.zG)(fp.N.Ord, fp/* OrdM.reverse */.gt.reverse, fp/* OrdM.contramap */.gt.contramap((category)=>(_fees = category.fees) !== null && _fees !== void 0 ? _fees : 0));
    const combinedCategoriesPerTimeFrame = (0,react.useMemo)(()=>{
        return (0,fp/* pipe */.zG)(time_frames/* timeFrames */.hN, fp.RA.toArray, fp.A.map((timeFrame)=>{
            // We disable a few time frames which are waiting on backend fixes.
            // This could be done more cleanly. First gather time frame and data
            // pairs then map the one where data is not unavailable.
            if ([
                "m5"
            ].includes(timeFrame)) {
                return [
                    timeFrame,
                    fp.O.none
                ];
            }
            var _category, _category1, _category2;
            const categoryFromCategories = (category)=>{
                return (0,fp/* pipe */.zG)({
                    id: category.category,
                    imgName: (_category = imgMap[category.category]) !== null && _category !== void 0 ? _category : {
                        coloron: question_mark_own,
                        coloroff: question_mark_slateus
                    },
                    imgAlt: (_category1 = imgAltMap[category.category]) !== null && _category1 !== void 0 ? _category1 : "question mark signaling missing image",
                    fees: category === null || category === void 0 ? void 0 : category.fees,
                    feesUsd: category === null || category === void 0 ? void 0 : category.feesUsd,
                    transactionCount: category === null || category === void 0 ? void 0 : category.transactionCount,
                    percentOfTotalBurn: category === null || category === void 0 ? void 0 : category.percentOfTotalBurn,
                    percentOfTotalBurnUsd: category === null || category === void 0 ? void 0 : category.percentOfTotalBurnUsd,
                    onHoverCategory: (hovering)=>dispatchHover({
                            type: hovering ? "highlight" : "unhighlight",
                            category: category.category
                        }),
                    showHighlight: (_category2 = hoverState[category.category]) !== null && _category2 !== void 0 ? _category2 : false
                });
            };
            const apiBurnCategories = (0,fp/* pipe */.zG)(burnCategories, fp.O.fromNullable, fp.O.chain(fp.O.fromNullableK((categories)=>categories[timeFrame])), fp.O.map(fp.A.map(categoryFromCategories)));
            var ref;
            // ethTransfers is a special case that we hack on in the frontend.
            const ethTransfers = (0,fp/* pipe */.zG)(leaderboard, fp.O.fromNullable, fp.O.map(fp.A.filter((entry)=>entry.type === "eth-transfers")), fp.O.chain(fp.A.head), fp.O.map((transfers)=>({
                    imgName: imgMap.transfers,
                    id: "transfers",
                    imgAlt: "missing icon for ETH transfer fees",
                    fees: transfers.fees,
                    feesUsd: transfers.feesUsd,
                    transactionCount: undefined,
                    percentOfTotalBurn: transfers.fees / burnSum.sum.eth / 1e18,
                    percentOfTotalBurnUsd: transfers.feesUsd / burnSum.sum.usd,
                    onHoverCategory: (hovering)=>dispatchHover({
                            type: hovering ? "highlight" : "unhighlight",
                            category: "transfers"
                        }),
                    showHighlight: (ref = hoverState["transfers"]) !== null && ref !== void 0 ? ref : false
                })));
            var ref1;
            // contractCreations is a special case that we hack on in the frontend.
            const contractDeployments = (0,fp/* pipe */.zG)(leaderboard, fp.O.fromNullable, fp.O.map(fp.A.filter((entry)=>entry.type === "contract-creations")), fp.O.chain(fp.A.head), fp.O.map((creations)=>({
                    imgName: imgMap.creations,
                    id: "creations",
                    imgAlt: "missing icon for contract creation fees",
                    fees: creations.fees,
                    feesUsd: creations.feesUsd,
                    transactionCount: undefined,
                    percentOfTotalBurn: creations.fees / burnSum.sum.eth / 1e18,
                    percentOfTotalBurnUsd: creations.feesUsd / burnSum.sum.usd,
                    onHoverCategory: (hovering)=>dispatchHover({
                            type: hovering ? "highlight" : "unhighlight",
                            category: "creations"
                        }),
                    showHighlight: (ref1 = hoverState["creations"]) !== null && ref1 !== void 0 ? ref1 : false
                })));
            var ref2;
            // contractCreations is a special case that we hack on in the frontend.
            const blobFees = (0,fp/* pipe */.zG)(feesBurned, fp.O.fromNullable, fp.O.map((blobFees)=>({
                    imgName: imgMap.blobs,
                    id: "blobs",
                    imgAlt: "missing icon for contract blob fees",
                    fees: blobFees[BlobBurnWidget.timeframeFeesBurnedMap[timeFrame]["eth"]],
                    feesUsd: blobFees[BlobBurnWidget.timeframeFeesBurnedMap[timeFrame]["usd"]],
                    transactionCount: undefined,
                    percentOfTotalBurn: blobFees[BlobBurnWidget.timeframeFeesBurnedMap[timeFrame]["eth"]] / burnSum.sum.eth / 1e18,
                    percentOfTotalBurnUsd: blobFees[BlobBurnWidget.timeframeFeesBurnedMap[timeFrame]["usd"]] / burnSum.sum.usd,
                    onHoverCategory: (hovering)=>dispatchHover({
                            type: hovering ? "highlight" : "unhighlight",
                            category: "blobs"
                        }),
                    showHighlight: (ref2 = hoverState["blobs"]) !== null && ref2 !== void 0 ? ref2 : false
                })));
            var ref3;
            const miscCategory = (0,fp/* pipe */.zG)(burnCategories, fp.O.fromNullable, fp.O.map((categories)=>buildMiscCategory(categories[timeFrame], activeCategories, (hovering)=>dispatchHover({
                        type: hovering ? "highlight" : "unhighlight",
                        category: "misc"
                    }), (ref3 = hoverState["misc"]) !== null && ref3 !== void 0 ? ref3 : false)));
            const combinedCategories = (0,fp/* pipe */.zG)(fp/* OAlt.sequenceTuple */.n.sequenceTuple(apiBurnCategories, ethTransfers, contractDeployments, blobFees, miscCategory), fp.O.map((param)=>{
                let [apiCategories, ethTransfers, contractDeployments, blobFees, miscCategory] = param;
                return (0,fp/* pipe */.zG)(apiCategories, fp.A.filter((category)=>activeCategories.includes(category.id)), (categories)=>[
                        ...categories,
                        ethTransfers,
                        contractDeployments,
                        blobFees,
                        miscCategory
                    ], fp.A.sort(sortByFeesDesc));
            }));
            return [
                timeFrame,
                combinedCategories
            ];
        }), fp/* Record.fromEntries */.WV.fromEntries);
    }, [
        burnCategories,
        burnSum.sum.eth,
        burnSum.sum.usd,
        hoverState,
        leaderboard,
        sortByFeesDesc
    ]);
    var _id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnGroupBase, {
        backgroundClassName: "h-[624px]",
        onClickTimeFrame: onClickTimeFrame,
        title: "burn categories",
        timeFrame: timeFrame,
        children: (0,fp/* pipe */.zG)(combinedCategoriesPerTimeFrame[timeFrame], fp.O.match(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n                flex h-[394px] w-full items-center justify-center\n                text-center text-lg text-slateus-200\n              ",
                children: "time frame unavailable"
            }), (categories)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex items-center py-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute w-full h-2 rounded-full color-animation bg-slateus-600"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex top-0 left-0 z-10 flex-row items-center w-full",
                                    children: categories.map((category, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySegmentItem, {
                                            isFirst: index === 0,
                                            isLast: index === categories.length - 1,
                                            category: category
                                        }, category.id);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid items-center ".concat(showCategoryCounts ? "md:grid-cols-3" : "grid-cols-2"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                        children: "category"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "\n                      text-right\n                      ".concat(showCategoryCounts ? "col-span-1" : "col-span-1", "\n                      ").concat(showCategoryCounts ? "md:mr-8" : "", "\n                    "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                            children: "burn"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                        className: "hidden text-right ".concat(showCategoryCounts ? "md:block" : ""),
                                        children: "transactions"
                                    })
                                ]
                            }),
                            categories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryRow, {
                                    amountFormatted: formatFees(category.fees),
                                    id: category.id,
                                    countFormatted: formatCount(category.transactionCount),
                                    hovering: (_id = hoverState[category.id]) !== null && _id !== void 0 ? _id : false,
                                    name: categoryDisplayMap[category.id],
                                    setHovering: dispatchHover,
                                    showCategoryCounts: showCategoryCounts
                                }, category.id))
                        ]
                    })
                ]
            })))
    });
};
/* harmony default export */ var components_BurnCategoryWidget = (BurnCategoryWidget);

// EXTERNAL MODULE: ./node_modules/lodash/flow.js
var flow = __webpack_require__(59242);
var flow_default = /*#__PURE__*/__webpack_require__.n(flow);
// EXTERNAL MODULE: ./src/components/Twemoji.tsx
var Twemoji = __webpack_require__(63365);
;// CONCATENATED MODULE: ./src/components/SpanMoji.tsx


const SpanMoji = (param)=>/*#__PURE__*/ {
    let { className , imageClassName ="h-[30px]" , emoji  } = param;
    return (0,jsx_runtime.jsx)(Twemoji/* default */.Z, {
        className: className,
        imageClassName: imageClassName,
        wrapper: true,
        children: emoji
    });
};
/* harmony default export */ var components_SpanMoji = (SpanMoji);

;// CONCATENATED MODULE: ./src/mainsite/components/BurnRecords.tsx












const formatBlockNumber = (u)=>typeof u !== "number" ? undefined : flow_default()(format/* formatZeroDecimals */.UY, (str)=>"#".concat(str))(u);
const getBlockPageLink = (u)=>typeof u === undefined ? undefined : "https://etherscan.io/block/".concat(u);
const emojiMap = [
    "\uD83E\uDD47",
    "\uD83E\uDD48",
    "\uD83E\uDD49",
    "4️⃣",
    "5️⃣",
    "6️⃣",
    "7️⃣",
    "8️⃣",
    "9️⃣",
    "\uD83D\uDD1F"
];
const Age = (param)=>{
    let { minedAt  } = param;
    const [age, setAge] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (minedAt === undefined) {
            return;
        }
        const now = new Date();
        const intervalId = window.setInterval(()=>{
            var ref;
            setAge((ref = format/* formatDurationToNow */.cj(now, minedAt)) !== null && ref !== void 0 ? ref : "??");
        }, 500);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        minedAt
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
        font: "font-inter",
        size: "text-base md:text-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
            width: "6rem",
            children: age === undefined ? undefined : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                        font: "font-roboto",
                        children: age
                    }),
                    " ago"
                ]
            })
        })
    });
};
const BurnRecords = (param)=>{
    let { onClickTimeFrame , timeFrame  } = param;
    const groupedAnalysis1F = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const groupedAnalysis1 = (0,grouped_analysis_1/* decodeGroupedAnalysis1 */.h)(groupedAnalysis1F);
    const burnRecords = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.burnRecords;
    const timeFrameRecords = burnRecords === undefined ? new Array(10).fill({}) : burnRecords[timeFrame];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnGroupBase, {
        onClickTimeFrame: onClickTimeFrame,
        timeFrame: timeFrame,
        title: "burn records",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "\n          mt-4 -mr-3 flex\n          h-72 flex-col\n          gap-y-6\n          overflow-y-auto md:h-96\n          ".concat((Scrollbar_module_default())["styled-scrollbar-vertical"], "\n          ").concat((Scrollbar_module_default())["styled-scrollbar"], "\n        "),
            children: timeFrameRecords.map((record, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-y-1 pr-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* QuantifyTextAnimated */.Ix, {
                                    size: "text-2xl md:text-3xl",
                                    skeletonWidth: "4rem",
                                    unit: "eth",
                                    unitText: "ETH",
                                    children: record.baseFeeSum
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpanMoji, {
                                    className: "select-none text-2xl md:text-3xl",
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    emoji: emojiMap[index]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: getBlockPageLink(record.blockNumber),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-animation font-roboto font-light text-slateus-400 hover:opacity-60 md:text-lg",
                                        children: formatBlockNumber(record.blockNumber) || /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            width: "8rem"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Age, {
                                    minedAt: record.minedAt
                                })
                            ]
                        })
                    ]
                }, record.blockNumber || index))
        })
    });
};
/* harmony default export */ var components_BurnRecords = (BurnRecords);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__(59910);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var legacy_image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./src/assets/fire-own.svg
var fire_own = __webpack_require__(83915);
// EXTERNAL MODULE: ./src/dates.ts
var dates = __webpack_require__(71119);
// EXTERNAL MODULE: ./src/duration.ts
var duration = __webpack_require__(5964);
// EXTERNAL MODULE: ./src/mainsite/hooks/use-pos-issuance-day.ts
var use_pos_issuance_day = __webpack_require__(25222);
;// CONCATENATED MODULE: ./src/mainsite/components/BurnTotal.tsx
















const timeframeFeesBurnedMap = {
    m5: {
        eth: "feesBurned5m",
        usd: "feesBurned5mUsd"
    },
    h1: {
        eth: "feesBurned1h",
        usd: "feesBurned1hUsd"
    },
    d1: {
        eth: "feesBurned24h",
        usd: "feesBurned24hUsd"
    },
    d7: {
        eth: "feesBurned7d",
        usd: "feesBurned7dUsd"
    },
    d30: {
        eth: "feesBurned30d",
        usd: "feesBurned30dUsd"
    },
    since_merge: {
        eth: "feesBurnedSinceMerge",
        usd: "feesBurnedSinceMergeUsd"
    },
    since_burn: {
        eth: "feesBurnedSinceBurn",
        usd: "feesBurnedSinceBurnUsd"
    }
};
const timeframeBurnRateMap = {
    m5: {
        eth: "burnRate5m",
        usd: "burnRate5mUsd"
    },
    h1: {
        eth: "burnRate1h",
        usd: "burnRate1hUsd"
    },
    d1: {
        eth: "burnRate24h",
        usd: "burnRate24hUsd"
    },
    d7: {
        eth: "burnRate7d",
        usd: "burnRate7dUsd"
    },
    d30: {
        eth: "burnRate30d",
        usd: "burnRate30dUsd"
    },
    since_merge: {
        eth: "burnRateSinceMerge",
        usd: "burnRateSinceMergeUsd"
    },
    since_burn: {
        eth: "burnRateSinceBurn",
        usd: "burnRateSinceBurnUsd"
    }
};
const timeFrameMillisecondsMap = {
    d30: duration/* millisFromDays */.kY(30),
    d7: duration/* millisFromDays */.kY(7),
    d1: duration/* millisFromHours */.QN(24),
    h1: duration/* millisFromHours */.QN(1),
    m5: duration/* millisFromMinutes */.wb(5)
};
const BurnTotal = (param)=>{
    let { onClickTimeFrame , timeFrame , unit  } = param;
    const groupedAnalysis1F = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const groupedAnalysis1 = groupedAnalysis1F !== undefined ? (0,grouped_analysis_1/* decodeGroupedAnalysis1 */.h)(groupedAnalysis1F) : undefined;
    const burnRates = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.burnRates;
    const feesBurned = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.feesBurned;
    const [millisecondsSinceLondonHardFork, setMillisecondsSinceLondonHardfork] = (0,react.useState)();
    const [millisecondsSinceMerge, setMillisecondsSinceMerge] = (0,react.useState)();
    const posIssuancePerDay = (0,use_pos_issuance_day/* usePosIssuancePerDay */.I)();
    const selectedFeesBurnedEth = feesBurned === undefined ? undefined : feesBurned[timeframeFeesBurnedMap[timeFrame]["eth"]];
    // In ETH or USD K.
    const selectedFeesBurned = feesBurned === undefined ? undefined : unit === "eth" ? feesBurned[timeframeFeesBurnedMap[timeFrame]["eth"]] : feesBurned[timeframeFeesBurnedMap[timeFrame][unit]];
    // In ETH / min or USD K / min.
    const selectedBurnRate = burnRates === undefined ? undefined : unit === "eth" ? burnRates[timeframeBurnRateMap[timeFrame][unit]] : burnRates[timeframeBurnRateMap[timeFrame][unit]];
    const issuancePerMillisecond = posIssuancePerDay / duration/* millisFromDays */.kY(1);
    (0,react.useEffect)(()=>{
        setMillisecondsSinceLondonHardfork(differenceInMilliseconds/* default */.Z(new Date(), dates/* londonHardFork */.b9));
        setMillisecondsSinceMerge(differenceInMilliseconds/* default */.Z(new Date(), dates/* parisHardFork */.Lk));
    }, []);
    // In ETH.
    const selectedIssuance = millisecondsSinceLondonHardFork === undefined || millisecondsSinceMerge === undefined ? undefined : timeFrame === "since_burn" ? issuancePerMillisecond * millisecondsSinceLondonHardFork : timeFrame === "since_merge" ? issuancePerMillisecond * millisecondsSinceMerge : issuancePerMillisecond * timeFrameMillisecondsMap[timeFrame];
    // Fraction.
    const issuanceOffset = selectedIssuance === undefined || selectedFeesBurnedEth === undefined ? undefined : format/* ethFromWei */.zQ(selectedFeesBurnedEth) / selectedIssuance;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetErrorBoundary/* default */.Z, {
        title: "burn total",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pointer-events-none absolute left-0 right-0 top-0 bottom-0 overflow-hidden rounded-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "\n              top-15\n              absolute -left-20 h-full\n              w-full opacity-[0.13]\n              blur-[50px]\n              will-change-transform\n              md:top-20\n              md:blur-[70px]\n            ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "\n                absolute h-4/5 w-4/5 rounded-[35%] bg-[#243AFF]\n                md:h-3/5\n                md:w-3/5\n              "
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "\n              absolute\n              top-0 -left-20 h-full\n              w-full opacity-[0.25]\n              blur-[50px]\n              will-change-transform md:top-5\n              md:blur-[70px]\n            ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "\n                absolute -left-5\n                h-4/5 w-full rounded-[35%] bg-[#FF8D24] md:left-0\n                md:h-3/5\n                md:w-4/5\n              "
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-baseline justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            children: "burn total"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameIndicator/* default */.Z, {
                            onClickTimeFrame: onClickTimeFrame,
                            timeFrame: timeFrame
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-y-4 pt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* AmountAnimatedShell */.au, {
                                    skeletonWidth: "9rem",
                                    size: "text-2xl md:text-3xl lg:text-3xl xl:text-4xl",
                                    unitText: unit === "eth" ? "ETH" : "USD",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                        decimals: unit === "eth" ? 2 : 0,
                                        duration: 0.8,
                                        end: selectedFeesBurned === undefined ? 0 : unit === "eth" ? format/* ethFromWei */.zQ(selectedFeesBurned) : selectedFeesBurned,
                                        preserveValue: true,
                                        separator: ","
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-4 h-6 w-6 select-none md:ml-8 lg:h-8 lg:w-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((legacy_image_default()), {
                                        alt: "fire emoji symbolizing ETH burned",
                                        src: fire_own/* default */.Z
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-between gap-y-4 lg:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            children: "burn rate"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* AmountAnimatedShell */.au, {
                                            skeletonWidth: "4rem",
                                            size: "text-2xl md:text-3xl lg:text-2xl xl:text-4xl",
                                            unitText: unit === "eth" ? "ETH/min" : "USD/min",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                decimals: unit === "eth" ? 2 : 1,
                                                duration: 0.8,
                                                end: selectedBurnRate === undefined ? 0 : unit === "eth" ? format/* ethFromWei */.zQ(selectedBurnRate) : selectedBurnRate / 1000,
                                                preserveValue: true,
                                                separator: ",",
                                                suffix: unit === "usd" ? "K" : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-4 lg:text-right",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            children: "issuance offset"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                            font: "font-roboto",
                                            size: "text-2xl md:text-3xl lg:text-2xl xl:text-4xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                decimals: 2,
                                                duration: 0.8,
                                                separator: ",",
                                                end: issuanceOffset !== null && issuanceOffset !== void 0 ? issuanceOffset : 0,
                                                preserveValue: true,
                                                suffix: "x"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_BurnTotal = (BurnTotal);

// EXTERNAL MODULE: ./src/mainsite/components/CurrencyControl.tsx
var CurrencyControl = __webpack_require__(51508);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInSeconds/index.js
var differenceInSeconds = __webpack_require__(11699);
// EXTERNAL MODULE: ./src/mainsite/api/barrier.ts
var api_barrier = __webpack_require__(84450);
;// CONCATENATED MODULE: ./src/mainsite/api/block-lag.ts



const useBlockLag = ()=>{
    const { data  } = (0,swr_dist/* default */.ZP)("/api/fees/block-lag", fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromSeconds */.Io(4)
    });
    return data;
};

// EXTERNAL MODULE: ./src/components/TextsNext/LabelUnitText.tsx
var LabelUnitText = __webpack_require__(76688);
;// CONCATENATED MODULE: ./src/mainsite/components/LatestBlocks/index.tsx














const maxBlocks = 20;
const formatGas = (u)=>typeof u !== "number" ? undefined : format/* formatZeroDecimals */.UY(u / eth_units/* WEI_PER_GWEI */.c1);
const LatestBlocks_formatFees = (unit, fees, feesUsd)=>{
    if (unit === "eth") {
        return typeof fees === "number" ? format/* formatWeiTwoDigit */.yz(fees) : undefined;
    }
    return typeof feesUsd === "number" ? "".concat(format/* formatZeroDecimals */.UY(feesUsd)) : undefined;
};
const latestBlockFeesSkeletons = new Array(maxBlocks).fill({});
const Resyncing = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
        className: "animate-slow-pulse text-slateus-200",
        children: "waiting for next analysis..."
    });
const LatestBlockAge = ()=>{
    const groupedAnalysisF = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const groupedAnalysis1 = (0,grouped_analysis_1/* decodeGroupedAnalysis1 */.h)(groupedAnalysisF);
    const [timeElapsed, setTimeElapsed] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (groupedAnalysis1 === undefined) {
            return;
        }
        const lastBlock = groupedAnalysis1.latestBlockFees[0];
        if (lastBlock === undefined) {
            return;
        }
        const latestMinedBlockDate = new Date(lastBlock === null || lastBlock === void 0 ? void 0 : lastBlock.minedAt);
        setTimeElapsed(differenceInSeconds/* default */.Z(new Date(), latestMinedBlockDate));
        const intervalId = window.setInterval(()=>{
            setTimeElapsed(differenceInSeconds/* default */.Z(new Date(), latestMinedBlockDate));
        }, 1000);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        groupedAnalysis1
    ]);
    if (typeof timeElapsed === "number" && timeElapsed > 1800) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Resyncing, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-x-2 items-baseline truncate",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                color: "text-slateus-400",
                className: "whitespace-nowrap",
                children: "latest block"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelUnitText/* LabelUnitText */.B, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                    width: "1rem",
                    children: timeElapsed !== undefined ? String(timeElapsed) : undefined
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                className: "truncate",
                children: "seconds"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                color: "text-slateus-400",
                children: "old"
            })
        ]
    });
};
const LatestBlockRow = (param)=>/*#__PURE__*/ {
    let { barrier , baseFeePerGas , fees , feesUsd , number , unit  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "transition-opacity duration-700 animate-fade-in",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: number === undefined ? undefined : "https://etherscan.io/block/".concat(number),
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "grid grid-cols-3 hover:opacity-60",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                        color: "text-slateus-400",
                        size: "text-base md:text-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "7rem",
                            children: number === undefined ? undefined : format/* formatZeroDecimals */.UY(number)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                        className: "mr-1 text-right",
                        color: typeof baseFeePerGas === "number" && baseFeePerGas / eth_units/* WEI_PER_GWEI */.c1 > barrier ? "text-orange-400" : "text-blue-400",
                        size: "text-base md:text-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "1rem",
                            children: formatGas(baseFeePerGas)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantifyText/* default */.Z, {
                        className: "text-right",
                        unitPostfix: unit.toUpperCase(),
                        size: "text-base md:text-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                            width: "2rem",
                            children: LatestBlocks_formatFees(unit, fees, feesUsd)
                        })
                    })
                ]
            })
        })
    });
};
const LatestBlocks = (param)=>{
    let { unit  } = param;
    var ref;
    const groupedAnalysis1F = (0,grouped_analysis_1/* useGroupedAnalysis1 */.a)();
    const groupedAnalysis1 = (0,grouped_analysis_1/* decodeGroupedAnalysis1 */.h)(groupedAnalysis1F);
    const latestBlockFees = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.latestBlockFees;
    const blockLag = (ref = useBlockLag()) === null || ref === void 0 ? void 0 : ref.blockLag;
    const barrier = (0,api_barrier/* useBaseFeePerGasBarrier */.K)().barrier;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetBackground */.K, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            children: "block"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            className: "text-right",
                            children: "gas"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            className: "-mr-1 text-right",
                            children: "burn"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "\n            -mr-3 flex max-h-[248px]\n            flex-col gap-y-4 overflow-y-auto\n            pr-1\n            ".concat((Scrollbar_module_default())["styled-scrollbar-vertical"], "\n            ").concat((Scrollbar_module_default())["styled-scrollbar"], "\n          "),
                    children: (latestBlockFees === undefined ? latestBlockFeesSkeletons : latestBlockFees).slice(0, 6).map((param, index)=>/*#__PURE__*/ {
                        let { number , fees , feesUsd , baseFeePerGas  } = param;
                        return (0,jsx_runtime.jsx)(LatestBlockRow, {
                            barrier: barrier,
                            baseFeePerGas: baseFeePerGas,
                            fees: fees,
                            feesUsd: feesUsd,
                            number: number,
                            unit: unit
                        }, number || index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap gap-y-2 justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestBlockAge, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-x-2 items-baseline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelUnitText/* LabelUnitText */.B, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                        width: "0.5rem",
                                        children: blockLag
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelText/* default */.Z, {
                                    color: "text-slateus-400",
                                    children: "block lag"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_LatestBlocks = (LatestBlocks);

;// CONCATENATED MODULE: ./src/mainsite/sections/BurnDashboard.tsx











const BurnDashboard = (param)=>{
    let { timeFrame , onClickTimeFrame , onSetTimeFrame  } = param;
    const [unit, setUnit] = (0,react.useState)("eth");
    const onSetUnit = (0,react.useCallback)(setUnit, [
        setUnit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
        link: "burn",
        subtitle: "it's getting hot in here",
        title: "burn",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-8 w-full rounded-lg bg-slateus-700",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-y-8 md:flex-row md:justify-between lg:gap-y-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col row-start-1 gap-4 lg:flex-row lg:gap-x-4 lg:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    children: "time frame"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameControl/* default */.Z, {
                                    selectedTimeFrame: timeFrame,
                                    onSetTimeFrame: onSetTimeFrame
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col row-start-2 gap-y-4 md:row-start-1 lg:flex-row lg:gap-x-4 lg:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                    children: "currency"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyControl/* default */.Z, {
                                    selectedUnit: unit,
                                    onSetUnit: onSetUnit
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-y-4 w-full md:gap-x-4 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnTotal, {
                        onClickTimeFrame: onClickTimeFrame,
                        timeFrame: timeFrame,
                        unit: unit
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-4 lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:max-h-[499px] xl:max-h-[526px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnLeaderboard, {
                                onClickTimeFrame: onClickTimeFrame,
                                timeFrame: timeFrame,
                                unit: unit
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnCategoryWidget, {
                                onClickTimeFrame: onClickTimeFrame,
                                timeFrame: timeFrame
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:row-start-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LatestBlocks, {
                            unit: unit
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:row-end-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BurnRecords, {
                            onClickTimeFrame: onClickTimeFrame,
                            timeFrame: timeFrame
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var sections_BurnDashboard = (BurnDashboard);


/***/ })

}]);